  import { Component, Input, OnInit } from '@angular/core';
  import { DestroyService } from '../../../../services/destroy/destroy.service';
  import { AddressModel, OrderModel, OrderServiceProxy, OrderUpdateModel } from '../../../../../shared/service-proxies/event-service-proxy';
  import { takeUntil } from 'rxjs';
  import { DateFormatterPipe } from '../../../../pipes/date/date-formatter.pipe';
  import { ToastrService } from '../../../../services/toastr/toastr.service';
  import { ErrorService } from '../../../../services/error/error.service';

  @Component({
    selector: 'app-order-info-card',
    templateUrl: './order-info-card.component.html',
    styleUrl: './order-info-card.component.scss',
    providers: [DestroyService],
    standalone: false
})
  export class OrderInfoCardComponent {
    @Input() order: OrderModel = new OrderModel();
    @Input() orderOriginal: OrderModel = new OrderModel();
    
    orderLastState: OrderModel | null = null; 

    @Input() isLoading: boolean = false;

    orderForm: OrderUpdateModel = new OrderUpdateModel();

    btnsVisible: boolean = false;
    restoreBtnVisible: boolean = false; 

    isLoadingSend: boolean = false;

    constructor(private errorService: ErrorService, private toastrService: ToastrService, private _orderService: OrderServiceProxy, private destroyService: DestroyService, public dateFormatterPipe: DateFormatterPipe) { }

    ngOnChanges() {
      if (this.order) {
        this.orderOriginal = this.order.clone();
        this.order = this.order.clone();
        this.orderForm = this.order.clone();
      }
    }

    get customerAddress() {
      if (!this.order.address) {
        this.orderForm.address = new AddressModel();
      }
      return this.orderForm.address;
    }
    
    updateOrder() {
      this.isLoadingSend = true;
      this.customerAddress;
      this._orderService.update(this.order.id, this.orderForm)
        .pipe(takeUntil(this.destroyService.onDestroy$))
        .subscribe(res => {
          console.log(res);
          this.btnsVisible = false;
          this.isLoadingSend = false;
          this.order = res;
          this.toastrService.showSuccessToastr('Информация о заказе успешно редактирована!');
        }, error => {
          this.isLoadingSend = false;
          console.error(error);
          this.errorService.handleError(error, 'Не удалось редактировать информацию о заказе. Попробуйте позже.');
      })
    }

    changeOrderInfo(orderKey: string) {
        if (this.orderForm[orderKey] !== this.order[orderKey]) {
         this.btnsVisible = true;
         this.restoreBtnVisible = false

        } else {
          this.btnsVisible = false;
        }
       if (this.customerAddress.street == this.order.address.street && orderKey == 'address') this.btnsVisible = false;
        if (!this.orderForm[orderKey] && this.orderOriginal[orderKey] === '') {
          this.btnsVisible = false;
        }
      
    }
    
    resetForm() {
      this.orderOriginal = this.orderForm.clone();
      this.orderForm = this.order.clone();
      this.btnsVisible = false;
      this.restoreBtnVisible = true; 
    }

    restoreForm() {
      this.orderForm = this.orderOriginal.clone();
      this.btnsVisible = true;
      this.restoreBtnVisible = false;
    }
    

  }
